import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { Component, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ToastController,
} from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { errMsg } from "../../../text_control/error-msg";
import { CreditNoteService } from "../credit-node-service";
import { ADDRESS } from "../../../text_control/text_address";
import { BTN } from "../../../text_control/text_button";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { STORAGE } from "src/app/constant/storages";

export interface Phones {
  numbers: string;
}

export interface TelEN {
  telENName: string;
}

@Component({
  selector: "app-no-credit",
  templateUrl: "./no-credit.component.html",
  styleUrls: ["./no-credit.component.scss"],
})
export class NoCreditComponent implements OnInit {
  Active: number;
  public text_addr: any = {};
  public text_btn: any = {};
  reqBody: any;
  response: any;

  buyer_name: "";
  seller_id: null;
  building_no: "";
  building_name: "";
  house_no: "";
  room_no: "";
  floor: "";
  village_no: "";
  lane: "";
  road: "";
  postcode: "";
  email: "";

  datasave: any = [];
  phone: any = "";
  buyer_agree_tmp: any = "Y";
  dataAbb: any = [];
  sub_district: any;
  district: any;
  province: any;
  District: any = [];
  subDistrict: any = [];
  dataprovince = [];
  datadistrict: any = [];
  datasubdistrict: any = [];

  dataprovinces: any;
  datadistricts: any;
  datasubdistricts: any;
  zipcode: any;

  redioaddress = "";
  showaddrTH = false;
  showaddrEN = false;
  showTH = false;
  showEN = false;
  showaddr = false;
  showedit = false;
  showContinue = false;

  emailEN = "";
  telEN = "";
  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN: String = "";
  addrENOther = "";
  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showback = false;
  showrefresh = false;
  showsave = false;
  shownext = false;

  isNewTaxInvoice: boolean = false;
  template_lang: any = "TH";
  buyer_status: any;

  buyer_branch_no: any = "";
  buyer_citizen_id = "";
  buyer_company_name = "";
  buyer_fname = "";
  buyer_main_branch_no;
  buyer_passpost_id = "";
  buyer_phone = "";
  buyer_sname = "";
  buyer_tax_id: any = "";
  branch_no = "";
  type_addr: any = "";
  addr_id: any = "";

  address_status = "1";
  buyer_type = "";
  selectedDevice = "";

  showbranch1 = false;
  showbranch2 = true;
  postcodes: any = [];
  addr_agree_tmp: any = "Y";

  showbtn1 = true;
  showbtn2 = false;
  buyer_tax_id1 = "";
  buyer_branch_type = "";

  buyer_id: any;

  abb_no_ref: any = "";
  dataAddr: any = [];

  showOther = false;
  itemEN: any;

  showcard = true;
  noshowcard = false;
  cardplaceholder = "";
  cardID = true;
  isOldAbb: boolean = false;
  creditNoteLists: any = [];
  request: any;
  datalist: any;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    public storage: Storage,
    public apiservice: ApiserviceService,
    public toastController: ToastController,
    public alertController: AlertController,
    public appService: AppService,
    public router: Router,
    public loadingController: LoadingController,
    public cnService: CreditNoteService,
    private route: ActivatedRoute
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.text_addr = ADDRESS;
    this.text_btn = BTN;
    this.route.queryParams.subscribe((params) => {
      this.updatecustomer = params.updatecustomer;
      this.datalist = params.datalist;

      console.log("====params.datalist======", params.datalist);
      if (params.updatecustomer === "updatecustomer") {
        this.showedit = true;
        this.showaddr = true;
        this.showrefresh = false;
        this.shownext = true;
        this.showsave = false;
      } else {
        this.showedit = false;
        this.showaddr = false;
        this.showrefresh = true;
        this.shownext = false;
        this.showsave = true;
      }
      if (params.noName === "no_cn") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 3;
      }
    });
  }

  ngOnInit() {
    this.addressManual = false;
    this.groupAddress = this.appService.address_thai;
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupProvince = this.dataProvince.filter((item) => {
        return item.province.indexOf(val) > -1;
      });
      var x = document.getElementById("showSelectProvince");
      var y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }

  async getStorageData() {
    this.showedit = true;
    this.shownext = true;
    this.showContinue = false;
    const loading = await this.apiservice.loading();
    loading.present();

    let indx = 0;
    const resviewIndx = _getStorage(STORAGE.viewDataIndx);
    indx = resviewIndx;

    const res = _getStorage(STORAGE.searchCreditNode);
    this.reqBody = res.request;
    this.response = res.response;

    if (this.isOldAbb) {
      this.creditNoteLists = res.response.taxinvoice_list;
    } else {
      if (this.datalist === "datalist") {
        let response = _getStorage(STORAGE.listdataCreditnote);
        response = typeof response === "string" ? response : response;
        this.creditNoteLists = response;
      } else {
        this.creditNoteLists = res.response.buyer_data;
      }
    }

    if (this.datalist === "datalist") {
      this.showedit = true;
      this.shownext = true;
      this.showContinue = false;
      this.abb_no_ref = res.response.abb_no_ref;
      this.buyer_id = this.creditNoteLists[0].buyer_id;
      this.buyer_citizen_id = this.creditNoteLists[0].buyer_citizen_id;
      this.buyer_passpost_id = this.creditNoteLists[0].buyer_passpost_id;
      this.buyer_agree_tmp = this.creditNoteLists[0].buyer_agree_tmp;
      this.template_lang = this.creditNoteLists[0].template_lang;
      this.buyer_status = this.creditNoteLists[0].buyer_status;

      this.buyer_name = this.creditNoteLists[0].buyer_company_name;
      this.building_no = this.creditNoteLists[0].address_detail[0].building_no;
      this.building_name =
        this.creditNoteLists[0].address_detail[0].building_name;
      this.house_no = this.creditNoteLists[0].address_detail[0].house_no;
      this.room_no = this.creditNoteLists[0].address_detail[0].room_no;
      this.floor = this.creditNoteLists[0].address_detail[0].floor;
      this.village_no = this.creditNoteLists[0].address_detail[0].village_no;
      this.lane = this.creditNoteLists[0].address_detail[0].lane;
      this.addr_id = this.creditNoteLists[0].address_detail[0].addr_id;
      this.road = this.creditNoteLists[0].address_detail[0].road;
      this.phone =
        this.creditNoteLists[0].address_detail[0].phone.indexOf(",") > -1
          ? this.creditNoteLists[0].address_detail[0].phone.split(",")
          : [this.creditNoteLists[0].address_detail[0].phone];
      this.email = this.creditNoteLists[0].address_detail[0].email;
      this.address_status =
        this.creditNoteLists[0].address_detail[0].address_status;
      this.seller_id = this.creditNoteLists[0].address_detail[0].seller_id;
      this.addr_agree_tmp =
        this.creditNoteLists[0].address_detail[0].addr_agree_tmp;
      this.itemEN = this.creditNoteLists[0].address_detail[0];
      this.type_addr = this.creditNoteLists[0].address_detail[0].type_addr;
      this.sub_district =
        this.creditNoteLists[0].address_detail[0].sub_district;
      this.district = this.creditNoteLists[0].address_detail[0].district;
      this.province = this.creditNoteLists[0].address_detail[0].province;
      this.postcode = this.creditNoteLists[0].address_detail[0].postcode;
      if (this.creditNoteLists[0].address_detail[0].type_addr === "1") {
        this.redioaddress = "1";
        this.showTH = true;
        this.showEN = true;
      } else {
        this.redioaddress = "2";
        this.showTH = true;
        this.showEN = true;
      }

      let country: any;
      country = this.dataCountry.filter(
        (i) => i.name.trim().toLowerCase() === this.itemEN.inter_country.trim().toLowerCase()
      );
      if (country.length > 0) {
        this.addrENCountry = country[0].name + ":" + country[0].code;
      }

      this.addrENPostCode = this.itemEN.inter_postcode;
      this.addrENProvince = this.itemEN.inter_province;
      this.addrEN = this.itemEN.inter_address_line1;
      this.emailEN = this.itemEN.email;
      this.telEN = this.itemEN.inter_tel;
      this.phones = [];
      this.phone = "";

      if (this.creditNoteLists[0].address_detail[0].phone != "") {
        if (this.creditNoteLists[0].address_detail[0].phone.indexOf(",") > -1) {
          this.creditNoteLists[0].address_detail[0].phone
            .split(",")
            .forEach((p) => {
              this.phones.push({ numbers: p });
            });
        } else {
          this.phones.push({
            numbers: this.creditNoteLists[0].address_detail[0].phone,
          });
        }
      }
      this.postcode = this.creditNoteLists[0].address_detail[0].postcode;
      this.buyer_branch_type =
        this.buyer_main_branch_no == "" ? "BRANCH" : "MAIN";
    } else if (res.response.buyer_data.length > 0) {
      this.dataAddr = res.response.buyer_data[indx];
      this.isNewTaxInvoice = false;
      let buyer = res.response.buyer_data[indx];

      this.abb_no_ref = res.response.abb_no_ref;
      this.buyer_id = buyer.buyer_id;
      this.buyer_citizen_id = buyer.buyer_citizen_id;
      this.buyer_passpost_id = buyer.buyer_passpost_id;
      this.buyer_agree_tmp = buyer.buyer_agree_tmp;
      this.template_lang = buyer.template_lang;
      this.buyer_status = buyer.buyer_status;

      this.buyer_name = buyer.buyer_company_name;
      this.building_no = buyer.building_no;
      this.building_name = buyer.building_name;
      this.house_no = buyer.house_no;
      this.room_no = buyer.room_no;
      this.floor = buyer.floor;
      this.village_no = buyer.village_no;
      this.lane = buyer.lane;
      this.addr_id = buyer.addr_id;
      this.road = buyer.road;
      this.sub_district = buyer.sub_district;
      this.district = buyer.district;
      this.province = buyer.province;
      this.postcode = buyer.postcode;
      this.phone =
        buyer.phone.indexOf(",") > -1 ? buyer.phone.split(",") : [buyer.phone];
      this.email = buyer.email;
      this.address_status = buyer.address_status;
      this.seller_id = buyer.seller_id;
      this.addr_agree_tmp = buyer.addr_agree_tmp;
      this.type_addr = buyer.type_addr;
      this.itemEN = buyer;
      if (buyer.type_addr === "1") {
        this.redioaddress = "1";
        this.showTH = true;
        this.showEN = true;
      } else {
        this.redioaddress = "2";
        this.showTH = true;
        this.showEN = true;
      }
      let country: any;
      country = this.dataCountry.filter(
        (i) => i.name.trim().toLowerCase() === this.itemEN.inter_country.trim().toLowerCase()
      );
      if (country.length > 0) {
        this.addrENCountry = country[0].name + ":" + country[0].code;
      }

      this.addrENPostCode = this.itemEN.inter_postcode;
      this.addrENProvince = this.itemEN.inter_province;
      this.addrEN = this.itemEN.inter_address_line1;
      this.emailEN = this.itemEN.email;
      this.telEN = this.itemEN.inter_tel;

      this.phones = [];
      this.phone = "";

      if (buyer.phone != "") {
        if (buyer.phone.indexOf(",") > -1) {
          buyer.phone.split(",").forEach((p) => {
            this.phones.push({ numbers: p });
          });
        } else {
          this.phones.push({ numbers: buyer.phone });
        }
      }
      this.postcode = buyer.postcode;
      this.buyer_branch_type =
        this.buyer_main_branch_no == "" ? "BRANCH" : "MAIN";
    } else {
      this.redioaddress = "1";
      this.showaddr = false;
      this.showEN = true;
      this.showrefresh = true;
      this.showsave = true;
      this.showback = true;
      this.showedit = false;
      this.showContinue = false;
      this.shownext = false;
      this.isNewTaxInvoice = true;
      this.buyer_tax_id = this.reqBody.cn_cid.match(/[0-9]*/)[0];
      this.buyer_tax_id1 = this.reqBody.cn_cid;
    }

    loading.dismiss();
  }

  updatecustomer: any;
  async ionViewDidEnter() {
    var showprovince = document.getElementById("showSelectProvince");
    var notshowprovince = document.getElementById("notshowselectProvince");

    if (showprovince !== null) {
      showprovince.style.display = "none";
      notshowprovince.style.display = "none";
    }
    this.reloadcountry();
    this.showback = true;

    this.buyer_name = "";
    this.building_no = "";
    this.building_name = "";
    this.house_no = "";
    this.village_no = "";
    this.room_no = "";
    this.floor = "";
    this.lane = "";
    this.road = "";
    this.postcode = "";
    this.phone = "";
    this.email = "";

    this.phone = "";
    this.buyer_agree_tmp = "Y";
    this.dataAbb = [];
    this.sub_district = "";
    this.district = "";
    this.province = "";
    this.showaddrTH = false;
    this.showaddrEN = false;

    this.emailEN = "";
    this.telEN = "";
    this.addrENCountry = "";
    this.addrENPostCode = "";
    this.addrENProvince = "";
    this.addrEN = "";
    this.addrENOther = "";
    this.dataCountry = [];
    this.country = "";
    this.dataCountrysearch = [];
    this.reloadcountry();
    await this.getStorageData();
  }

  checkredioaddr() {
    if (this.redioaddress === "1") {
      this.showTH = false;
      this.showEN = true;
    }
    if (this.redioaddress === "2") {
      this.showTH = true;
      this.showEN = false;
    }
  }

  checkaddressTH() {
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.showTH = true;
    this.showEN = false;
  }
  reloadcountry() {
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  phones: Phones[] = [];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;

    // Add our fruit
    if ((value || "").trim()) {
      this.phones.push({ numbers: value.trim() });
    }

    // Reset the input value
    if (input) {
      input.value = "";
    }
  }

  remove(phone: Phones): void {
    const index = this.phones.indexOf(phone);

    if (index >= 0) {
      this.phones.splice(index, 1);
    }
  }

  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }

  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkpostcode(e) {
    this.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }
  checkemail(e) {
    this.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  dataTH: any;
  dataEN: any;

  async save() {
    let isConfirm = false;
    let province = this.province;
    let district = this.district;
    let sub_district = this.sub_district;
    let phones = [];

    for (let i of this.phones) {
      phones.push(i.numbers);
    }

    if (this.redioaddress === "1") {
      let filterPostcode = this.groupAddress.filter(
        (f) => f.zipcode === Number(this.postcode)
      );
      let filterProvince = this.groupAddress.filter(
        (f) => f.province === this.province
      );
      if (!isConfirm) {
        if (this.buyer_name === "") {
          this.ErrorMsg(errMsg.buyer_company_name);
        } else if (this.house_no === "") {
          this.ErrorMsg(errMsg.house_no);
        } else if (this.postcode === "") {
          this.ErrorMsg(errMsg.postcode);
        } else if (this.postcode !== "" && filterPostcode.length === 0) {
          this.ErrorMsg(errMsg.notpostcode);
        } else if (sub_district === "") {
          this.ErrorMsg(errMsg.sub_district);
        } else if (district === "") {
          this.ErrorMsg(errMsg.district);
        } else if (province === "") {
          this.ErrorMsg(errMsg.province);
        } else if (province !== "" && filterProvince.length === 0) {
          this.ErrorMsg(errMsg.notprovince);
        } else {
          isConfirm = true;
        }
      }
    } else {
      if (!isConfirm) {
        if (this.buyer_name === "") {
          this.ErrorMsg(errMsg.buyer_company_name);
        } else if (
          this.addrENProvince === "" ||
          this.addrENProvince === undefined
        ) {
          this.ErrorMsg(errMsg.addrENProvince);
        } else if (
          this.addrENPostCode === "" ||
          this.addrENPostCode === undefined
        ) {
          this.ErrorMsg(errMsg.addrENPostCode);
        } else if (
          this.addrENCountry === "" ||
          this.addrENCountry === undefined
        ) {
          this.ErrorMsg(errMsg.addrENCountry);
        } else {
          isConfirm = true;
        }
      }
    }

    const req_new_customer = {
      newCustomerData: {
        buyer_company_name: this.buyer_name,
        buyer_people_id: "",
        buyer_main_branch_no: "",
        buyer_branch_no: "",
        buyer_citizen_id: "",
        buyer_tax_id: "",
        buyer_passpost_id: "",
        buyer_type: "3",
        buyer_agree_tmp: this.buyer_agree_tmp, // ===>>> key tmp [ ยินยอม Y / ไม่ยินยอม N]
        user_id: this.userID,
        template_lang: this.redioaddress === "1" ? "TH" : "EN",
        buyer_status: "active",
        address_detail: {
          type_addr: this.redioaddress,
          building_no: this.building_no,
          building_name: this.building_name,
          house_no: this.house_no,
          village_no: this.village_no,
          room_no: this.room_no,
          floor: this.floor,
          lane: this.lane,
          road: this.road,
          sub_district: sub_district,
          district: district,
          province: province,
          postcode: String(this.postcode),
          phone: phones.join(","),
          email: this.redioaddress === "1" ? this.email : this.emailEN,
          address_status: "active",
          addr_agree_tmp: this.buyer_agree_tmp,
          seller_id: "",
          buyer_id: "",
          user_id: this.userID,
          inter_country: !this.addrENCountry ? "" : this.addrENCountry,
          inter_tel: !this.telEN ? "" : this.telEN,
          inter_province: !this.addrENProvince ? "" : this.addrENProvince,
          inter_postcode: !this.addrENPostCode ? "" : this.addrENPostCode,
          inter_address_line1: !this.addrEN ? "" : this.addrEN,
          inter_fax: "",
        },
      },
    };
    const req_up_customer = {
      updateCustomerData: {
        buyer_id: this.buyer_id,
        buyer_company_name: this.buyer_name,
        buyer_people_id: null,
        buyer_main_branch_no: "",
        buyer_branch_no: "",
        buyer_citizen_id: this.buyer_citizen_id,
        buyer_tax_id: this.buyer_tax_id,
        buyer_type: "3",
        buyer_passpost_id: this.buyer_passpost_id,
        buyer_agree_tmp: this.buyer_agree_tmp,
        user_id: this.userID,
        buyer_status: this.buyer_status,
        template_lang: this.template_lang,
        address_detail: {
          addr_id: this.addr_id,
          building_no: this.building_no,
          building_name: this.building_name,
          house_no: this.house_no,
          village_no: this.village_no,
          room_no: this.room_no,
          floor: this.floor,
          lane: this.lane,
          road: this.road,
          sub_district: sub_district === undefined ? "" : sub_district,
          district: district === undefined ? "" : district,
          province: province === undefined ? "" : province,
          postcode: String(this.postcode),
          phone: phones.join(","),
          email: this.redioaddress === "1" ? this.email : this.emailEN,
          buyer_id: this.buyer_id,
          address_status: this.buyer_status,
          seller_id: "",
          addr_agree_tmp: this.buyer_agree_tmp,
          user_id: this.userID,
          type_addr: this.redioaddress,
          inter_address_line1: this.addrEN === undefined ? "" : this.addrEN,
          inter_country: this.addrENCountry,
          inter_fax: "",
          inter_postcode: this.addrENPostCode,
          inter_province: this.addrENProvince,
          inter_tel: this.telEN === undefined ? "" : this.telEN,
        },
      },
    };
    if (isConfirm) {
      let req_cn_notaxid: any;
      if (this.redioaddress === "1") {
        if (this.updatecustomer === "updatecustomer") {
          req_cn_notaxid = req_up_customer;
        } else {
          req_cn_notaxid = req_new_customer;
        }
      }
      if (this.redioaddress === "2") {
        if (this.updatecustomer === "updatecustomer") {
          req_cn_notaxid = req_up_customer;
        } else {
          req_cn_notaxid = req_new_customer;
        }
      }

      console.log("========== req update customer ==========", req_cn_notaxid);

      try {
        this.apiservice
          ._post(
            this.apiservice.apiUrl + this.apiservice.updateCustomer,
            req_cn_notaxid
          )
          .then(async (res: any) => {
            console.log("=========== res update customer ==========", res);

            if (res.statusCode === 200) {
              this.datasave = res.data;
              let setdata = await this.cnService.setTaxinvoiceList(this.datasave);
              _setStorage(STORAGE.verifyCreditNote, setdata);
              const alert = await this.alertController.create({
                cssClass: "my-custom-class",
                message: "บันทึกข้อมูลเรียบร้อย",
                buttons: [
                  {
                    text: "OK",
                    cssClass: "alertButton",
                    handler: (blah) => {
                      this.showTH = true;
                      this.showEN = true;
                      this.showaddr = true;
                      this.showrefresh = false;
                      this.showsave = false;
                      this.showContinue = true;
                      this.showback = false;
                    },
                  },
                ],
              });
              await alert.present();
            } else {
              this.ErrorMsg(res.statusMessage);
            }
          });
      } catch (error) {
        // this.ErrorMsg(errMsg.error);
      }
    }
  }
  goBackPage() {
    if (this.datalist === "datalist") {
      this.router.navigate(["/credit-note-tax-list"], {
        queryParams: {
          noName: "no_cn",
          selectedIndex: "4",
          datalist: "datalist",
        },
      });
    } else {
      this.router.navigate(["/credit-note-tax-list"], {
        queryParams: { noName: "no_cn", selectedIndex: "4" },
      });
    }
  }
  editdata() {
    this.showedit = false;
    this.showaddr = false;
    this.showsave = true;
    this.shownext = false;
    if (this.itemEN.type_addr === "1") {
      this.redioaddress = "1";
      this.showTH = false;
      this.showEN = true;
    } else if (this.itemEN.type_addr === "2") {
      this.redioaddress = "2";
      this.showTH = true;
      this.showEN = false;
    }
  }
 async Continue() {
    let setdata =await this.cnService.setTaxinvoiceList(this.datasave);
    _setStorage(STORAGE.listdataCreditnote, this.datasave);
    _setStorage(STORAGE.verifyCreditNote, setdata);
    this.router.navigate(["/credit-check-taxinvoice"], {
      queryParams: { noName: "no_cn", selectedIndex: "4" },
    });
  }

  async setnextstorage() {
    const res = _getStorage(STORAGE.viewDataIndx);
    if (res != null) {
      let verifyData: any;

      if (!this.isOldAbb) {
        verifyData = await this.cnService.setTaxinvoiceList([
          this.creditNoteLists[res],
        ]);
      } else {
        verifyData = this.creditNoteLists[res];
      }
      _setStorage(STORAGE.verifyCreditNote,verifyData)
      if (this.Active === 3) {
        this.router.navigate(["/credit-check-taxinvoice"]);
      } else {
        this.router.navigate(["/credit-check-taxinvoice"], {
          queryParams: { noName: "no_cn", selectedIndex: "4" },
        });
      }
    } else {
      let setdata = await this.cnService.setTaxinvoiceList(this.datasave);
      _setStorage(STORAGE.verifyCreditNote,setdata)
      this.router.navigate(["/credit-check-taxinvoice"], {
        queryParams: { noName: "no_cn", selectedIndex: "4" },
      });
    }
  }
}
